import styled from "styled-components";
import StyledInputText from "@components/StyledInputText";

export const RoundedInputText = styled(StyledInputText)`
  border-radius: 40px;
`;

export default RoundedInputText;
